import { Button, Stack, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { ImageService } from "../../../../services/image/imageService";
import { ChangeEvent, useCallback, useContext, useState } from "react";
import { AppContext } from "../../../../contexts/AppContext";
import { toast } from "react-toastify";


interface Props {
    asset: string,
    name: string,
}


const ImageRow = ({ asset, name }: Props) => {
    const { jwtToken, server } = useContext(AppContext);
    const [date, _] = useState<number>(Date.now());

    const [imgSrc, __] = useState(ImageService.getImgUrl(asset));

    const [, updateState] = useState();
    const forceUpdate = useCallback(() => updateState(undefined), []);

    const uploadImage = async (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) {
            return;
        }

        const file = e.target.files[0];

        if (jwtToken && server) {
            const reader = new FileReader();
            reader.onload = async (evt) => {
                if (!evt?.target?.result) {
                    return;
                }

                const formData = new FormData();
                formData.append("file", file);

                const res = await ImageService.uploadImg(jwtToken, asset, formData);

                if (res.status === 200) {
                    forceUpdate();
                    toast("Fichier téléversé avec succès!");
                } else {
                    toast("Échec de téléversement.");
                }
            }
            reader.readAsText(file);
        }
    }

    return (
        <Stack direction="row" sx={{"overflowX": "auto"}} spacing={2}>
            <img key={date} src={imgSrc} width={80} height={80} style={{ "margin": 10 }} ></img>
            <Typography>{name}</Typography>

            <Button
                component="label"
                variant="outlined"
                startIcon={<UploadFileIcon />}>
                Téléverser
                <input type="file" accept={'.png'} hidden onChange={uploadImage} />
            </Button>
        </Stack>
    );
}


export default ImageRow;